module.exports = __webpack_public_path__ + "img/forgot-password-v2.cdb8f691.svg";